// Module-level holder for the Supabase access token so api.ts can inject it
// into Authorization headers without depending on React context. The
// CompanyAuthProvider keeps this in sync with the Supabase session.

let currentAccessToken: string | null = null;

export function setCompanyAccessToken(token: string | null): void {
  currentAccessToken = token;
}

export function getCompanyAccessToken(): string | null {
  return currentAccessToken;
}
